import React, { useContext, useEffect, useState } from "react";
import Footer from "src/components/Footer";
import Navbar from "src/components/Navbar";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { node_url, url } from "src/helpers";
import { toast } from "react-toastify";
import { userContext } from "src/context/UserContext";
import Newlayout from "src/New Codes/NewLayout/Newlayout";
import NewHeader from "src/New Codes/components/NewHeader";

function Home() {
  const { setLoad, user } = useContext(userContext);
  const [list, setList] = useState([])

  const options = {
    loop: true,
    margin: 30,
    nav: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      850: {
        items: 2,
      },
      1200: {
        items: 3,
      },
    },
  };

  const banner_options = {
    loop: true,
    margin: 30,
    nav: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      850: {
        items: 1,
      },
      1200: {
        items: 1,
      },
    },
  };

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");

  async function handelSendEmail(e) {
    setLoad(true);
    e.preventDefault();

    const data = {
      name,
      email,
      message: description,
      status: "pending",
    };

    const response = await fetch(url + "submit-contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (response.ok == true) {
      const data = await response.json();
      setLoad(false);
      toast.success("Email Send Successfully!");
    } else {
      setLoad(false);
      toast.error("Internal Server Error!");
    }
  }

  async function fetchBanners() {
    const response = await fetch(url + 'fetch-banners')

    if (response.ok == true) {
      const data = await response.json()
      setList(data?.list)
    }
  }

  useEffect(() => {
    fetchBanners()
  }, [])
  return (
    <>

      <NewHeader />

      {/* <Newlayout/> */}
      {/* <Navbar type="half" /> */}

      {/* < slider code */}
      {list?.length > 0 && <>
        <OwlCarousel
          className="owl-theme home-testimonials"
          {...banner_options}
        >
          {list?.map((item, index) => (
            <div key={index} className="home-slider-main-Y">
              <div className="banner-slider" style={{ backgroundImage: `url(${node_url + item?.image_url})` }}>
                <div className="container-lg slider_container">
                  <div className="row">


                    <div className="col-xl-7 col-md-10">
                      <div className="slide_heading mb-4">
                        <h5 className="fw-normal mb-3"> BEBA MZIGO </h5>
                        <h1 className="custom-home-banner-text mb-3">
                          {item?.title}
                        </h1>
                        <h5 className="fw-normal">
                          {item?.description}
                        </h5>
                      </div>
                    </div>
                    <div className="d-flex flex-wrap gap-3">
                      <a href={user?.token ? "/dashboard" : "/login"} className="join_us">
                        <button className="btn rounded-pill d-flex gap-2">
                          {" "}
                          <i class="fa-solid fa-boxes-stacked me-1"></i> Ship a
                          Package
                        </button>
                      </a>
                      <a href={user?.token ? "/dashboard" : "/login"} className="join_us">
                        <button className="btn rounded-pill d-flex gap-2">
                          <i class="fa-solid fa-ship me-1"></i> Find Shipments
                        </button>
                      </a>
                      <a href={user?.token ? "/dashboard" : "/login"} className="join_us">
                        <button className="btn rounded-pill d-flex gap-2">
                          <i class="fa-solid fa-location-dot"></i> Track Your Item
                        </button>
                      </a>
                      {/* <button className="download_app">DOWNLOAD APP</button> */}
                    </div>
                    <div className="col-xl-2 col-md-2"></div>

                  </div>
                </div>
              </div>
            </div>
          ))}
        </OwlCarousel>
      </>}


      {/* Trusted by code */}
      <div class="section pt-35 pb-35 page_speed_478581128">
        <div class="container-lg slider_container">
          <div class="row align-items-center">
            <div class="col-lg-4 text-lg-start">
              <p class="font-2xl-bold color-brand-2 text-center text-lg-left mt-4 mt-lg-0 mb-1 mb-lg-2">
                {" "}
                <span class="color-brand-1">Trusted</span> by Industry Leaders
              </p>
              <p className="mb-3 fw-normal font-sm fst-italic text-center text-lg-left">
                "We partner with leading enterprises to streamline logistics
                across East Africa."
              </p>
            </div>
            <div class="col-lg-8 mb-30">
              <div className="our_partner_main">
                <div className="our_partners_wrapper_img my-0">
                  <div className="container-lg">
                    <div className="row">
                      <div className="col-md-4 text-center d-flex align-items-center">
                        <div className="our_partners_img">
                          <a href="https://demisystems.co.ke" target="_blank">
                            <img
                              src="./assets/images/demi-systems.png"
                              alt=""
                            />
                          </a>
                        </div>
                      </div>
                      <div className="col-md-4 text-center d-flex align-items-center">
                        <div className="our_partners_img">
                          <a href="https://demishop.co.ke" target="_blank">
                            <img src="./assets/images/demi-shop.jpg" alt="" />
                          </a>
                        </div>
                      </div>
                      <div className="col-md-4 text-center d-flex align-items-center">
                        <div className="our_partners_img mb-0">
                          <a href="https://luthuli.co.ke" target="_blank">
                            <img src="./assets/images/luthuli.png" alt="" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* our services code */}
      <div className="our-services-main-Y">
        <div className="slider custom-background-container">
          <div className="our_services">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="our_services_head mb-4">
                    <h2>Our Services</h2>
                    <div className="d-flex justify-content-between">
                      <p>End-to-end logistics, powered by technology.</p>
                      {/* <a
                        className="join_us d-flex align-items-center justify-content-center text-decoration-none"
                        href="/#contact-us"
                      >
                        <button className="btn">Contact Us</button>
                      </a> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-xl-4 col-md-6">
                  <div class="card-offer hover-up">
                    <div class="card-image">
                      <img
                        src="/assets/images/new-images/cargo-ship.png"
                        alt=""
                      />
                    </div>
                    <div class="card-info">
                      <p class="font-sm color-grey-900 mb-35">
                        Cargo Deliveries. Safe transportation of medium to large goods across towns and regions.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-md-6">
                  <div class="card-offer hover-up">
                    <div class="card-image">
                      <img src="/assets/images/new-images/plane.png" alt="" />
                    </div>
                    <div class="card-info">
                      <p class="font-sm color-grey-900 mb-35">
                        Freight Services. Efficient bulk and heavy-load transport for businesses moving goods locally or across borders.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-md-6">
                  <div class="card-offer hover-up">
                    <div class="card-image">
                      <img
                        src="/assets/images/new-images/delivery.png"
                        alt=""
                      />
                    </div>
                    <div class="card-info">
                      <p class="font-sm color-grey-900 mb-35">
                        Shipping Solutions. Seamless coordination of goods by road, air, or sea to ensure smooth and timely delivery.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-md-6">
                  <div class="card-offer hover-up">
                    <div class="card-image">
                      <img
                        src="/assets/images/new-images/forklift.png"
                        alt=""
                      />
                    </div>
                    <div class="card-info">
                      <p class="font-sm color-grey-900 mb-35">
                        Warehousing Support. Secure storage solutions to keep your goods safe before distribution or delivery.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-md-6">
                  <div class="card-offer hover-up">
                    <div class="card-image">
                      <img
                        src="/assets/images/new-images/worldwide.png"
                        alt=""
                      />
                    </div>
                    <div class="card-info">
                      <p class="font-sm color-grey-900 mb-35">
                        Last-Mile Deliveries. Fast and reliable doorstep delivery for small packages within cities and nearby areas.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Why Choose Beba Mzigo?  code */}
      <section class="section pt-110 pb-110 bg-white why-us-section">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-xl-7">
              <div className="why-us-card-section">
                <div class="row">
                  <div class="col-md-6">
                    <div class="item-reason">
                      <div class="card-offer card-offer-custom cardServiceStyle3 hover-up">
                        <div class="card-image">
                          <img
                            src="/assets/images/new-images/container1.png"
                            alt="img"
                          />
                        </div>
                        <div class="card-info">
                          <h5 class="color-brand-2 mb-15">
                            Transparent Pricing & Secure Payments
                          </h5>
                          <p class="font-sm color-grey-900">
                            See costs upfront with protected payment systems.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="item-reason">
                      <div class="card-offer card-offer-custom cardServiceStyle3 hover-up">
                        <div class="card-image">
                          <img
                            src="/assets/images/new-images/stopwatch.png"
                            alt="img"
                          />
                        </div>
                        <div class="card-info">
                          <h5 class="color-brand-2 mb-15">
                            Real-Time Tracking & Updates
                          </h5>
                          <p class="font-sm color-grey-900">
                            Monitor your goods from pickup to delivery.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-30">
                    <div class="item-reason">
                      <div class="card-offer card-offer-custom cardServiceStyle3 hover-up">
                        <div class="card-image">
                          <img
                            src="/assets/images/new-images/24-hours.png"
                            alt="img"
                          />
                        </div>
                        <div class="card-info">
                          <h5 class="color-brand-2 mb-15">
                            Vetted & Verified Network
                          </h5>
                          <p class="font-sm color-grey-900">
                            Every transporter is verified for safe, reliable
                            service.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="item-reason">
                      <div class="card-offer card-offer-custom cardServiceStyle3 hover-up">
                        <div class="card-image">
                          <img
                            src="/assets/images/new-images/pallet.png"
                            alt="img"
                          />
                        </div>
                        <div class="card-info">
                          <h5 class="color-brand-2 mb-15">Scale On Demand</h5>
                          <p class="font-sm color-grey-900">
                            Access thousands of vehicles—from trucks to boda
                            bodas.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-5">
              <div class="box-info-pround box-whychooseus-3 why-us-section-head">
                <h2 class="color-brand-2 mb-4 mt-20">
                  Why Choose Beba Mzigo?{" "}
                </h2>
                <p className="mb-3 fw-normal font-md">
                  <i>"We built a trusted ecosystem that works for everyone."</i>
                </p>

                <p class=" color-grey-900">
                  Sustainability is an increasingly important factor for many
                  customers when choosing a shipping company. Your shipping
                  company can stand out by demonstrating a commitment to
                  sustainable practices, such as using energy-efficient
                  vehicles, reducing waste, and offsetting carbon emissions.
                </p>
                <div class="mt-30">
                  <ul class="list-ticks">
                    <li>
                      <svg
                        class="w-6 h-6 icon-16"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>{" "}
                      Reliable and Timely Deliveries{" "}
                    </li>
                    <li>
                      <svg
                        class="w-6 h-6 icon-16"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>{" "}
                      Advanced Tracking Systems{" "}
                    </li>
                    <li>
                      <svg
                        class="w-6 h-6 icon-16"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>{" "}
                      Cost-Effective Shipping Options{" "}
                    </li>
                    <li>
                      <svg
                        class="w-6 h-6 icon-16"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>{" "}
                      Commitment to Sustainability{" "}
                    </li>
                    <li>
                      <svg
                        class="w-6 h-6 icon-16"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>{" "}
                      Exceptional Customer Service{" "}
                    </li>
                    <li>
                      <svg
                        class="w-6 h-6 icon-16"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>{" "}
                      International Shipping Expertise{" "}
                    </li>
                    <li>
                      <svg
                        class="w-6 h-6 icon-16"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>{" "}
                      Flexibility and Customization{" "}
                    </li>
                    <li>
                      <svg
                        class="w-6 h-6 icon-16"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>{" "}
                      Insurance and Liability Coverage{" "}
                    </li>
                  </ul>
                </div>
                <div class="mt-30 text-start">
                  <a class="btn contact-us mr-3" href="/#contact-us">
                    {" "}
                    Contact Us{" "}
                  </a>
                  <a class="learn-more" href="/#contact-us">
                    <button class="btn pe-2">Learn More</button>
                    <i class="fa-solid fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* get in touch */}
      <section class="section bg-1 position-relative pt-90 pb-90">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 get-in-touch-div">
              <span class="btn btn-tag mb-2">Great Services</span>
              <h3 class="color-grey-900 mb-20 mt-15">
                {" "}
                Proud to Deliver <br /> Excellence Every Time{" "}
              </h3>
              <p class="font-md color-grey-900 mb-40">
                {" "}
                Our team consistently delivers with integrity, ensuring that
                every detail aligns with the highest standards. Through
                strategic thinking and innovative approaches, we drive growth
                that goes beyond convention—always looking ahead, always
                thinking forward.{" "}
              </p>
              <div class="row">
                <div class="col-xl-6 mb-30">
                  <h6 class="chart-title font-md-bold color-grey-900 page_speed_1371078957">
                    {" "}
                    Boost your sale{" "}
                  </h6>
                  <p class="font-xs color-grey-900 custom-line-height-22">
                    Leverage cutting-edge design and optimized layouts to
                    attract more customers and increase conversions.
                  </p>
                </div>
                <div class="col-xl-6 mb-30">
                  <h6 class="chart-title font-md-bold color-grey-900 page_speed_516480949">
                    {" "}
                    Introducing New Features{" "}
                  </h6>
                  <p class="font-xs color-grey-900 custom-line-height-22">
                    Stay ahead with powerful new tools designed to enhance
                    performance, usability, and user experience.
                  </p>
                </div>
              </div>
              <div class="mt-20">
                <a class="btn contact-us mr-3" href="/#contact-us">
                  {" "}
                  Contact Us{" "}
                </a>
                <a class="learn-more" href="/#contact-us">
                  <button className="btn pe-2">Learn More</button>
                  <i class="fa-solid fa-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="box-image-touch page_speed_997191832"></div>
      </section>

      {/* Our Work Force */}
      <section class="section pt-90 pb-65 page_speed_1980940376 bg-white">
        <div class="container">
          <div class="text-center work-force-header">
            <p class="font-md color-grey-700 fst-italic mb-1">
              Delivering Results for Industry Leaders{" "}
            </p>
            <hr />
            <h2 class="color-brand-2 mb-65 mt-4">
              We are proud of our workforce <br /> and have worked hard.{" "}
            </h2>
          </div>
          <div class="row mt-50 align-items-center">
            <div class="col-xxl-7 mb-50">
              <div class="box-images-pround">
                <div class="box-images page_speed_383169026">
                  <img
                    class="img-main"
                    src="/assets/images/new-images/img1.png"
                    alt="We are proud of our workforce &lt;br&gt; and have worked hard."
                  />
                </div>
              </div>
            </div>
            <div class="col-xxl-5">
              <div class="box-info-pround">
                <h3 class="color-brand-2 mb-4">
                  Fast shipping with the most modern technology{" "}
                </h3>
                <p class="font-md color-grey-500">
                  Over the years, we have worked together to expand our network
                  of trusted partners, enabling us to deliver unmatched
                  reliability and consistency across all touchpoints. By
                  cultivating long-term relationships with industry leaders and
                  service providers, we’ve created a strong foundation that
                  supports seamless operations and responsive service.
                </p>
                <p class="font-md color-grey-500">
                  Our commitment to innovation, collaboration, and operational
                  excellence continues to drive value for our clients, allowing
                  them to stay ahead in an increasingly competitive and
                  fast-moving environment.
                </p>
                <div class="mt-4 ">
                  <ul class="list-ticks">
                    <li>
                      <svg
                        class="icon-16"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>{" "}
                      Task tracking{" "}
                    </li>
                    <li>
                      <svg
                        class="icon-16"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>{" "}
                      Create task dependencies{" "}
                    </li>
                    <li>
                      <svg
                        class="icon-16"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>{" "}
                      Task visualization{" "}
                    </li>
                    <li>
                      <svg
                        class="icon-16"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>{" "}
                      Hare files, discuss{" "}
                    </li>
                    <li>
                      <svg
                        class="icon-16"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>{" "}
                      Meet deadlines faster{" "}
                    </li>
                    <li>
                      <svg
                        class="icon-16"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>{" "}
                      Track time spent on project{" "}
                    </li>
                  </ul>
                </div>
                {/* <div class="mt-4 gap-2 text-start d-flex">
                  <a
                    class="hover-up me-2"
                    href="https://apps.apple.com/us/app/"
                  >
                    <img
                      src="https://transp.botble.com/storage/general/appstore-btn.png"
                      alt="Apple Store"
                    />
                  </a>
                  <a class="hover-up" href="https://play.google.com/store/apps">
                    <img
                      src="https://transp.botble.com/storage/general/google-play-btn.png"
                      alt="Google Play"
                    />
                  </a>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about us code */}
      <div className="why-us-main-Y">
        <div className="slider page_speed_871836 py-3" id="why-us">
          <div className="why_us py-5">
            <div className="container">
              <div class="text-center mb-5">
                <h2 class="color-2 mb-15">
                  {" "}
                  World’s Leading Companies <br /> For Over 80 Years.{" "}
                </h2>
                <p class="font-md text-white">
                  A big opportunity for your business growth. Delivering Results
                  for Industry Leaders. We are <br /> proud of our work for and
                  have worked hard.
                </p>
              </div>
              <div class="row">
                <div class="col-xl-3 col-md-6 col-sm-6 mb-30">
                  <div class="cardLeadingCompany">
                    <div class="cardImage">
                      <span class="img">
                        <img
                          src="/assets/images/new-images/handover.png"
                          alt="Parcels Shipped Safely"
                        />
                      </span>
                    </div>
                    <div class="cardInfo">
                      <h3 class="color-2">+ 380,000</h3>
                      <p class="font-lg text-white">Parcels Shipped Safely</p>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-6 col-sm-6 mb-30">
                  <div class="cardLeadingCompany">
                    <div class="cardImage">
                      <span class="img">
                        <img
                          src="/assets/images/new-images/cities.png"
                          alt="Cities Served Worldwide"
                        />
                      </span>
                    </div>
                    <div class="cardInfo">
                      <h3 class="color-2">+ 120,000</h3>
                      <p class="font-lg text-white">Cities Served Worldwide</p>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-6 col-sm-6 mb-30">
                  <div class="cardLeadingCompany">
                    <div class="cardImage">
                      <span class="img">
                        <img
                          src="/assets/images/new-images/client.png"
                          alt="Satisfied Clients"
                        />
                      </span>
                    </div>
                    <div class="cardInfo">
                      <h3 class="color-2">+2280</h3>
                      <p class="font-lg text-white">Satisfied Clients</p>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-6 col-sm-6 mb-30">
                  <div class="cardLeadingCompany">
                    <div class="cardImage">
                      <span class="img">
                        <img
                          src="/assets/images/new-images/company.png"
                          alt="Company We Help"
                        />
                      </span>
                    </div>
                    <div class="cardInfo">
                      <h3 class="color-2">+ 1200</h3>
                      <p class="font-lg text-white">Company We Help</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* how it works */}
      <section class="section pt-85 pb-65 bg-worldmap page_speed_2121036651 how-it-works bg-white">
        <div class="container custom-index">
          <div class="text-center how-it-works-header">
            <p class="font-md color-grey-700 fst-italic mb-1">
              Your Journey from Click to Doorstep.
            </p>
            <hr />
            <h2 class="color-brand-2 mb-20 mt-4"> How It Works </h2>
            <p class="font-md color-grey-700">
              {" "}
              You choose the cities where you’d like to deliver. All deliveries
              are within a specific service area and delivery services vary by
              location. Whatever the mode or requirement, we will find and book
              the ideal expedited shipping solution to ensure a timely delivery.{" "}
            </p>
          </div>
          <div class="row mt-50">
            <div class="col-lg-6 mb-30">
              <div class="box-image-how">
                <img
                  class="w-100"
                  src="/assets/images/new-images/how-it-work.png"
                  alt="homepage/how-it-work.png"
                />
              </div>
            </div>
            <div class="col-lg-6 mb-30 d-flex align-items-center">
              <ul class="list-how-works pt-lg-0 pt-3">
                <li>
                  <div class="image-how">
                    <span class="img">
                      <img
                        src="/assets/images/new-images/order.png"
                        alt=" Customer places order"
                      />
                    </span>
                  </div>
                  <div class="info-how">
                    <h5 class="color-brand-2"> Customer places order</h5>
                    <p class="font-md color-grey-700">
                      Inspection and quality check of goods
                    </p>
                  </div>
                </li>
                <li>
                  <div class="image-how">
                    <span class="img">
                      <img
                        src="/assets/images/new-images/payment.png"
                        alt="Payment successful"
                      />
                    </span>
                  </div>
                  <div class="info-how">
                    <h5 class="color-brand-2">Payment successful</h5>
                    <p class="font-md color-grey-700">
                      Payoneer, Paypal, or Visa master card
                    </p>
                  </div>
                </li>
                <li>
                  <div class="image-how">
                    <span class="img">
                      <img
                        src="/assets/images/new-images/warehouse.png"
                        alt="Warehouse receives order"
                      />
                    </span>
                  </div>
                  <div class="info-how">
                    <h5 class="color-brand-2">Warehouse receives order</h5>
                    <p class="font-md color-grey-700">
                      Check the accuracy of the goods.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="image-how">
                    <span class="img">
                      <img
                        src="/assets/images/new-images/picked.png"
                        alt="Item picked, packed &amp; shipped"
                      />
                    </span>
                  </div>
                  <div class="info-how">
                    <h5 class="color-brand-2">
                      Item picked, packed &amp; shipped
                    </h5>
                    <p class="font-md color-grey-700">
                      Ship the goods to a local carrier
                    </p>
                  </div>
                </li>
                <li>
                  <div class="image-how">
                    <span class="img">
                      <img
                        src="/assets/images/new-images/delivery.png"
                        alt="Delivered &amp; Measure success"
                      />
                    </span>
                  </div>
                  <div class="info-how">
                    <h5 class="color-brand-2">
                      Delivered &amp; Measure success
                    </h5>
                    <p class="font-md color-grey-700">
                      Update order status on the system
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* our client say code */}
      <div className="our_client_main">
        <div className="slider">
          <div className="our_client">
            <div className="container">
              <div class="text-center how-it-works-header">
                <p class="font-md color-grey-700 fst-italic mb-0">
                  Testimonials
                </p>
                <hr style={{ width: "5%" }} />
                <h2 class="color-brand-2 mb-20 mt-4 heading-testimonials">
                  What Our Clients Say{" "}
                </h2>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-12">
                  <div className="main-video">
                    <OwlCarousel
                      className="owl-theme home-testimonials"
                      {...options}
                    >
                      <div class="item">
                        <div className="bg-white p-4 rounded-3 testimonial-card">
                          <div>
                            <div className="qoute-icon d-flex justify-content-center mb-3">
                              <i
                                class="fa-solid fa-quote-left fa-4x"
                                style={{ color: "#d07726" }}
                              ></i>
                            </div>
                            <div className="content d-flex justify-content-center">
                              <p class="font-md color-grey-700 text-center mb-0">
                                Bebamzigo transformed our distribution. Finding
                                reliable transport is now instant and
                                hassle-free.
                              </p>
                            </div>
                            <hr
                              style={{ width: "10%" }}
                              className="d-flex mx-auto"
                            />
                          </div>

                          <div className="profile d-flex justify-content-center flex-column align-items-center">
                            <div className="profile-img mb-2">
                              <img
                                src="assets\images\testimonials\2.png"
                                alt="logo"
                                className="img-fluid rounded-pill border"
                                style={{
                                  height: "80px",
                                  width: "80px",
                                  // objectFit: "cover",
                                }}
                              />
                            </div>
                            <div className="profile-name">
                              <p class="font-sm color-grey-700 text-center mb-0 fst-italic">
                                — Logistics Manager, FMCG Company
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="item">
                        <div className="bg-white p-4 rounded-3 testimonial-card">
                          <div>
                            <div className="qoute-icon d-flex justify-content-center mb-3">
                              <i
                                class="fa-solid fa-quote-left fa-4x"
                                style={{ color: "#d07726" }}
                              ></i>
                            </div>
                            <div className="content d-flex justify-content-center">
                              <p class="font-md color-grey-700 text-center mb-0">
                                Bebamzigo has completely simplified how I move
                                goods for my shop. I can now find affordable
                                transport options in minutes.
                              </p>
                            </div>
                            <hr
                              style={{ width: "10%" }}
                              className="d-flex mx-auto"
                            />
                          </div>

                          <div className="profile d-flex justify-content-center flex-column align-items-center">
                            <div className="profile-img mb-2">
                              <img
                                src="assets\images\testimonials\3.png"
                                alt="logo"
                                className="img-fluid rounded-pill border"
                                style={{
                                  height: "80px",
                                  width: "80px",
                                  // objectFit: "cover",
                                }}
                              />
                            </div>
                            <div className="profile-name">
                              <p class="font-sm color-grey-700 text-center mb-0 fst-italic">
                                — Mira Mwangi — Small Business Owner
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="item">
                        <div className="bg-white p-4 rounded-3 testimonial-card">
                          <div>
                            <div className="qoute-icon d-flex justify-content-center mb-3">
                              <i
                                class="fa-solid fa-quote-left fa-4x"
                                style={{ color: "#d07726" }}
                              ></i>
                            </div>
                            <div className="content d-flex justify-content-center">
                              <p class="font-md color-grey-700 text-center mb-0">
                                As a driver, Bebamzigo has helped me find more
                                clients and fill my truck faster. I can plan my
                                routes better and earn more.
                              </p>
                            </div>
                            <hr
                              style={{ width: "10%" }}
                              className="d-flex mx-auto"
                            />
                          </div>

                          <div className="profile d-flex justify-content-center flex-column align-items-center">
                            <div className="profile-img mb-2">
                              <img
                                src="assets\images\testimonials\1.png"
                                alt="logo"
                                className="img-fluid rounded-pill border"
                                style={{
                                  height: "90px",
                                  width: "90px",
                                  // objectFit: "cover",
                                }}
                              />
                            </div>
                            <div className="profile-name">
                              <p class="font-sm color-grey-700 text-center mb-0 fst-italic">
                                — Peter Otieno — Truck Driver
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </OwlCarousel>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* contact us code */}
      <div className="contact_us_main">
        <div className="contact_us" id="contact-us">
          <div className="contact_us_wrapper box-form-contact-leading page_speed_1359682981">
            <div className="container-lg card border-0 rounded-3 px-lg-5 px-4 pt-65 pb-65">
              <div className="row">
                <div className="col-xl-6">
                  <div className="form pe-0 pe-lg-4">
                    <h2>Contact Us</h2>
                    <p class="font-md color-grey-700">
                      We’d love to hear from you! Whether you have a question,
                      feedback, or just want to say hello — our team is here to
                      help.
                    </p>
                    <form
                      onSubmit={(e) => {
                        handelSendEmail(e);
                      }}
                      className="row mt-4 "
                    >
                      <div className="form-group col-lg-6">
                        <label className="form-label">
                          Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter Full Name"
                          className="form-control mb-3"
                          required
                          onChange={(e) => {
                            setName(e.target.value);
                          }}
                        />
                        <div className="invalid-feedback">
                          <div>Fullname is required</div>
                        </div>
                      </div>

                      <div className="form-group  col-lg-6">
                        <label className="form-label">
                          Email <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter a valid email address"
                          className="form-control mb-3"
                          required
                          onChange={(e) => {
                            setEmail(e.target.value);
                          }}
                        />
                        <div className="invalid-feedback">
                          <div>Email is required</div>
                          <div>Email is invalid</div>
                        </div>
                      </div>

                      <div className="form-group text_area">
                        <label className="form-label">
                          Description <span className="text-danger">*</span>
                        </label>
                        <textarea
                          rows="5"
                          cols="56"
                          className="form-control"
                          style={{ height: "150px" }}
                          onChange={(e) => {
                            setDescription(e.target.value);
                          }}
                        ></textarea>
                      </div>
                      <div className="form-group mt-3">
                        <button type="submit" className="btn form-submit-btn">
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>

                <div class="col-xl-6 d-xl-block d-none">
                  <div class="box-image-contact">
                    <img
                      src="/assets/images/black-man-delivery.png"
                      alt="Calculate Shipping"
                      className="img-fluid"
                      style={{ objectFit: "cover", height: '65vh' }}
                    />
                  </div>
                </div>
              </div>
              <div className="row justify-content-center card_wrapper"></div>
            </div>
          </div>
        </div>
      </div>

      {/* our partner code */}
      <div className="our_partner_main d-none">
        <div className="our_partners">
          <div className="our_partners_wrapper">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="our_partners_head">
                    <h2>OUR PARTNERS</h2>
                    <hr />
                    <p className="text">
                      From a Kenyan start up to an African-wide trade platform{" "}
                      <br />
                      empowering over 1000k+ customers to achieve more.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="our_partners_wrapper_img">
            <div className="container">
              <div className="row">
                <div className="col-md-4 text-center">
                  <div className="our_partners_img">
                    <a href="https://demisystems.co.ke" target="_blank">
                      <img src="./assets/images/demi-systems.png" alt="" />
                    </a>
                  </div>
                </div>
                <div className="col-md-4 text-center">
                  <div className="our_partners_img">
                    <a href="https://demishop.co.ke" target="_blank">
                      <img src="./assets/images/demi-shop.jpg" alt="" />
                    </a>
                  </div>
                </div>
                <div className="col-md-4 text-center">
                  <div className="our_partners_img">
                    <a href="https://luthuli.co.ke" target="_blank">
                      <img src="./assets/images/luthuli.png" alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Home;
